import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';

// ----------------------------------------------------------------------------------------
// The auth guard is used to prevent unauthenticated users from accessing restricted routes
// ----------------------------------------------------------------------------------------

@Injectable()
export class AuthGuard  {

  constructor(private authService: AuthService, 
              private router: Router) {}

  canActivate() 
  {
    // console.log('--- AuthGuard Check authService --- ' + this.authService.checkLoginStatus());

    if(this.authService.checkLoginStatus()) 
    {
      return true;
    } 
    else 
    {
      this.authService.logout();
      // this.router.navigate(['/landing-page']);
      return false;
    }
  }
}
